export const environment = {
  APP_NAME: 'Cincinnati',
  API_BASE_URL: '/api',
  production: false,
  WS_URL: 'wss://cincinnati.of1.weborchestra.org/ws/8011',
};

